import axiosInstance, { getAccessToken } from './axiosConfig';
import { requireAuthToken } from '../utils/authUtils';

const productAPI = {
  /**
   * Get all products (admin only)
   * @param {string} storeId - Optional store ID filter
   * @returns {Promise} Array of products
   */
  getAll: async (storeId = null) => {
    try {
      requireAuthToken(getAccessToken);
      const params = storeId ? { storeId } : {};

      console.log('params', params);
      const response = await axiosInstance.get('/products', { params });



      console.log('getAll',response.data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch products';
    }
  },

  /**
   * Search products by name or barcode
   * @param {string} query - Search term
   * @param {string} storeId - Optional store ID filter
   * @returns {Promise} Array of matching products
   */
  search: async (query, storeId = null) => {
    try {
      requireAuthToken(getAccessToken);
      const params = { q: query };
      if (storeId) params.storeId = storeId;
      
      const response = await axiosInstance.get('/products/search', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to search products';
    }
  },

  /**
   * Create a new product (admin only)
   * @param {object} productData - Product data
   * @returns {Promise} Created product
   */
  create: async (productData) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await axiosInstance.post('/product', productData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to create product';
    }
  },

  /**
   * Update a product (admin only)
   * @param {string} id - Product ID
   * @param {object} updates - Product updates
   * @returns {Promise} Updated product
   */
  update: async (id, updates) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await axiosInstance.put(`/product/${id}`, updates);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to update product';
    }
  },

  /**
   * Delete a product (admin only)
   * @param {string} id - Product ID
   * @returns {Promise} Success message
   */
  delete: async (id) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await axiosInstance.delete(`/product/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to delete product';
    }
  },

  /**
   * Get product by ID
   * @param {string} id - Product ID
   * @returns {Promise} Product details
   */
  getById: async (id) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await axiosInstance.get(`/product/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch product';
    }
  },
  getByBarcode: async (barcode, storeId = null) => {
    try {
      requireAuthToken(getAccessToken);
      // Simple cache implementation
      if (!productAPI._barcodeCache) productAPI._barcodeCache = {};
      const cacheKey = `${barcode}-${storeId || 'all'}`;
      
      if (productAPI._barcodeCache[cacheKey]) {
        return productAPI._barcodeCache[cacheKey];
      }

      const params = { q: barcode, exactMatch: true };
      if (storeId) params.storeId = storeId;
      
      const response = await axiosInstance.get('/products/search', { params });

      //console.log('barcode response', response);

      const product = response.data.data.find(p => p.barcode === barcode);

      if (product) {
        productAPI._barcodeCache[cacheKey] = product;
        setTimeout(() => {
          delete productAPI._barcodeCache[cacheKey];
        }, 30000); // Cache for 30 seconds
      }

      return product || null;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch product by barcode';
    }
  }

};

export default productAPI;